export enum ContentLevelEnum {
  BOOK = 'book',
  CHAPTER = 'chapter',
}
